import { useState, useEffect } from "react";

const testimonials = [
  {
    text: "During Ayush’s internship in the cybersecurity department at SAC-ISRO, Ayush not only demonstrated remarkable skills but also showed a genuine eagerness to learn and tackle challenges head-on. Despite being new to the cybersecurity domain, his inquisitive nature and love for learning shone through in his problem-solving approach. Ayush was more than just his technical skills, his compassion and support made him an invaluable team member.",
    name: "Darshankumar K. Patel, Group Director, SCI-ENGR-SG, CITA-CISG, ISRO",
  },
];

export default function Testimonials() {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentTestimonial(
        (prevIndex) => (prevIndex + 1) % testimonials.length
      );
    }, 5000);

    return () => clearInterval(intervalId);
  }, []);

  return (
    <>
      <h1
        className="text-2xl ml-20 mt-20 transition duration-300 ease-in-out transform group hover:scale-105"
        data-aos="zoom-in-left"
        data-aos-duration="1500"
        data-aos-easing="ease-in-out"
      >
        <span className="block transition-transform duration-300 ease-in-out group-hover:translate-x-2">
          Testimonials
        </span>
      </h1>

      <div
        className="flex flex-col justify-center min-h-[80vh] px-4"
        data-aos="zoom-in"
        data-aos-duration="1800"
        data-aos-easing="ease-in-out"
      >
        <div className="flex flex-col items-center justify-center max-w-3xl mx-auto rounded-lg">
          <p className="text-lg italic mb-4 text-center">
            "{testimonials[currentTestimonial].text}"
          </p>
          <p className="font-semibold text-gray-400 text-center">
            - {testimonials[currentTestimonial].name}
          </p>
        </div>
      </div>
      <hr className="border-gray-600 mb-5" />

      {/* Mobile responsiveness */}
      <style jsx>{`
        @media (max-width: 640px) {
          .text-lg {
            font-size: 1rem; /* Smaller text size on mobile */
          }
          .text-center {
            text-align: center;
          }
          .px-4 {
            padding-left: 1rem;
            padding-right: 1rem;
          }
        }
      `}</style>
    </>
  );
}
